import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {AttributeLambdaParameters} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"
import {
    GeometryAttributeLambdaNode,
    attributeLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"

export type MeshGeometryAttributeLambdaParameters = AttributeLambdaParameters<2>

const definition: TemplateNodeDefinition<MeshGeometryAttributeLambdaParameters> = {
    nodeClass: "MeshGeometryAttributeLambda",
    validation: {
        parameters: attributeLambdaParametersSchema<2>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryAttributeLambda
    extends GeometryAttributeLambdaNode<2, MeshGeometryAttributeLambdaParameters>
    implements MeshGeometryAttributeLikeNode
{
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
